<p>
  {{(seeMoreFlag)? content.slice(0,showChar):content }}
  <a class="cursor-pointer text-success fnt-size12px" *ngIf="contentData?.length > showChar" (click)="SeeMore()">{{(seeMoreFlag)? this.translate.instant('READ_MORE') : this.translate.instant('READ_LESS')}}</a>
</p>
